<template>
  <div>
    <h3>币种及状态，次数——数据展示</h3>
    <el-table :data="countDataList" height="350" border style="width: 100%">
      <el-table-column prop="coinType" label="币种" > </el-table-column>
      <el-table-column prop="executionStatus" label="执行状态">
        <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.executionStatus==0">待执行</el-tag>
          <el-tag type="warning" v-else-if="scope.row.executionStatus==1">执行中</el-tag>
          <el-tag type="success" v-else-if="scope.row.executionStatus==2">已执行</el-tag>
          <el-tag color="yellow" v-else-if="scope.row.executionStatus==3">重新执行</el-tag>
          <el-tag type="danger" v-else>执行失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="numberSize" label="此状态出现的次数" > </el-table-column>
      
    </el-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
     
    };
  },
  computed: {
    ...mapState('blockHeightTask',['countDataList'])
  }
};
</script>

<style lang="less" scoped></style>
